import {Div, HeaderBack, Label} from 'components';
import {Ecolors, Icons} from 'constant';
import React, {useEffect, useState} from 'react';
import {ScrollView} from 'react-native';
import {navigate} from 'services';
import {apiMain} from 'services/apis/apiMain';
import {useAppSelector} from 'store/hooks';

function RowSpaceItem(p: {paddingTop?: number; children?: any}) {
  return (
    <Div
      minHeight={54}
      paddingHorizontal={16}
      borderBottomWidth={1}
      borderBottomColor={Ecolors.bgtime}
      paddingTop={p.paddingTop ?? 0}
      flexDirection={'row'}
      alignItems={'center'}
      justifyContent={'space-between'}>
      {p.children && p.children}
    </Div>
  );
}

function AddressInfoModal() {
  const [loading, setLoading] = useState<boolean>(false);
  const [permanentCountry, setPermanentCountry] = useState<any>(null);
  const [permanentProvince, setPermanentProvince] = useState<any>(null);
  const [mailingCountry, setMailingCountry] = useState<any>(null);
  const [mailingProvince, setMailingProvince] = useState<any>(null);
  const currentUser = useAppSelector(state => state.authen.currentUser);
  const {
    permanentAddress,
    countryId,
    provinceId,
    mailingAddress,
    mailingCountryId,
    mailingProvinceId,
    investmentProfile,
  } = currentUser;

  useEffect(() => {
    bindData();
    return () => {};
  }, []);

  const bindData = async () => {
    try {
      setLoading(true);
      const res = await Promise.all([
        apiMain.getCountry(),
        apiMain.getProvince({countryId: countryId}),
        apiMain.getProvince({countryId: mailingCountryId}),
      ]);
      const PCountry = res[0]?.data?.find((a: any) => a.id == countryId);
      const PProvince = res[1]?.data?.find((a: any) => a.id == provinceId);
      const MCountry = res[0]?.data?.find((a: any) => a.id == mailingCountryId);
      const MProvince = res[2]?.data?.find(
        (a: any) => a.id == mailingProvinceId,
      );
      await Promise.all([
        setMailingCountry(MCountry || null),
        setMailingProvince(MProvince || null),
        setPermanentCountry(PCountry || null),
        setPermanentProvince(PProvince || null),
      ]);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <Div height={'100%'} backgroundColor={Ecolors.whiteColor}>
      <HeaderBack
        loading={loading}
        type={2}
        iconRight={
          investmentProfile?.status?.code === 'INVESTMENT_PROFILE_PENDING'
            ? null
            : Icons.edit
        }
        onRightPress={() => {
          navigate('EditAddressInfoModal', {
            data: {
              permanentAddress,
              permanentProvince,
              permanentCountry,
              //
              mailingAddress,
              mailingProvince,
              mailingCountry,
            },
          });
        }}
        title={`accountverify.thongtindiachi`}
      />
      <ScrollView>
        <Div padding={16} backgroundColor={Ecolors.bgtime}>
          <Label multilanguage={false}>
            {`1. `}
            <Label>{`accountverify.diachithuongtru`}</Label>
          </Label>
        </Div>
        <RowSpaceItem>
          <Label>{`accountverify.quocgia`}</Label>
          <Div
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'flex-end'}
            paddingVertical={13}
            flex={1}
            paddingLeft={16}>
            <Label multilanguage={false}>{permanentCountry?.name || ''}</Label>
          </Div>
        </RowSpaceItem>
        <RowSpaceItem>
          <Label>{`accountverify.tinhthanhpho`}</Label>
          <Div
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'flex-end'}
            paddingVertical={13}
            flex={1}
            paddingLeft={16}>
            <Label multilanguage={false}>{permanentProvince?.name || ''}</Label>
          </Div>
        </RowSpaceItem>

        <RowSpaceItem>
          <Label>{`accountverify.diachithuongtru`}</Label>
          <Div
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'flex-end'}
            paddingVertical={13}
            flex={1}
            paddingLeft={16}>
            <Label textAlign="right" multilanguage={false}>
              {permanentAddress}
            </Label>
          </Div>
        </RowSpaceItem>
        <Div padding={16} backgroundColor={Ecolors.bgtime}>
          <Label multilanguage={false}>
            {`2. `}
            <Label>{`accountverify.diachilienhe`}</Label>
          </Label>
        </Div>
        <RowSpaceItem>
          <Label>{`accountverify.quocgia`}</Label>
          <Div
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'flex-end'}
            paddingVertical={13}
            flex={1}
            paddingLeft={16}>
            <Label multilanguage={false}>{mailingCountry?.name || ''}</Label>
          </Div>
        </RowSpaceItem>
        <RowSpaceItem>
          <Label>{`accountverify.tinhthanhpho`}</Label>
          <Div
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'flex-end'}
            paddingVertical={13}
            flex={1}
            paddingLeft={16}>
            <Label multilanguage={false}>{mailingProvince?.name || ''}</Label>
          </Div>
        </RowSpaceItem>

        <RowSpaceItem>
          <Label>{`accountverify.diachilienhe`}</Label>
          <Div
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'flex-end'}
            paddingVertical={13}
            flex={1}
            paddingLeft={16}>
            <Label textAlign="right" multilanguage={false}>
              {mailingAddress}
            </Label>
          </Div>
        </RowSpaceItem>
      </ScrollView>
    </Div>
  );
}

export default React.memo(AddressInfoModal);
